import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'

export const manageAccountContainer = css`
  padding: ${spacing(4, 4, 1, 4)};
  margin-bottom: ${spacing(0)};
`

export const sectionTitle = css`
  color: ${colors.white100};
  font-weight: 600;
` 